module.exports = __webpack_public_path__ + "static/media/tengoals.fb2847ed.jpg";